import { LogoWordmarkBrand } from '@eventbrite/eds-iconography';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import HeaderIcon, { IHeaderIconProps } from './HeaderIcon';

export interface IHeaderDecorationProps extends IHeaderIconProps {
    picture?: string;
    isLoading?: boolean;
}

const HeaderDecoration = ({
    iconType,
    iconColor,
    iconSize,
    iconBottomSpacing = 'eds-l-mar-bot-6',
    shouldNotModifyIcon,
    picture,
    isLoading,
}: IHeaderDecorationProps) => {
    let icon = null;
    const iconProps = {
        iconColor,
        iconSize,
        iconBottomSpacing,
        shouldNotModifyIcon,
    };

    if (!iconType) {
        icon = (
            <a
                href="/"
                rel="noopener noreferrer"
                title={gettext('Go to homepage').toString()}
            >
                <HeaderIcon iconType={<LogoWordmarkBrand />} {...iconProps} />
            </a>
        );
    }

    if (iconType) {
        icon = <HeaderIcon iconType={iconType} {...iconProps} />;
    }

    if (picture) {
        icon = (
            <img
                className="auth-lib__header__picture"
                src={picture}
                alt={picture}
            />
        );
    }

    if (isLoading) {
        icon = (
            <ProgressIndicator
                size="medium-chunky"
                shape="circular"
                style="gradient"
            />
        );
    }

    return icon;
};

export default HeaderDecoration;
